// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_VyPWp [role='columnheader'] {
  width: 38px !important;
  min-width: 38px !important;
  flex: 1 0 auto !important;
  padding: 0 !important;
  justify-content: center;
  height: auto;
  border-color: var(--color-base300) !important;

}
.table_VyPWp [role='columnheader']:first-child {
  width: 100px !important;
  max-width: 100px !important;
  padding: 8px 10px 8px 10px !important;
  justify-content: center;
}

.table_VyPWp [role='cell'] {
  width: 38px !important;
  min-width: 38px !important;
  flex: 1 0 auto !important;
  justify-content: center !important;
  padding: 0 !important;
  border-color: var(--color-base300) !important;
}
.table_VyPWp [role='cell']:first-child {
  width: 100px !important;
  max-width: 100px !important;
  justify-content: center !important;
  padding: 8px 10px 8px 10px !important;
  min-height: 55px !important;
}

.table_VyPWp [role='cell']:last-child {
  border-color: var(--color-base300) !important;
}

.table_VyPWp [role='row'] {
  min-width: max-content !important;
}

.table_VyPWp > div:not([role='rowgroup']) > [role='row'] [role='columnheader']:first-child,
.table_VyPWp > div:not([role='rowgroup']) > [role='row'] [role='columnheader']:nth-child(2) {
  background-color: var(--color-base050) !important;
}

.table_VyPWp > div:not([role='rowgroup']) > [role='row'] [role='columnheader']:nth-child(3) {
  background-color: #E2E6EA !important;
}

.table_VyPWp [role='cell']:first-child, .table_VyPWp [role='cell']:nth-child(2) {
  background-color: var(--color-base050) !important;
}

.table_VyPWp [role='cell']:nth-child(3) {
  background-color: #E2E6EA !important;
}


.table_VyPWp [role="row"]:last-child [role='cell'] {
  border-bottom: 0px;
}

.table_VyPWp > div:first-child > [role='row'] {
  min-height: 55px !important;
}

.row_APoki {
  width: 100%;
  height: 100%;
  font-size: 14px;
  text-align: center;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/factoryCycleTimeMonitoring/components/mobile/BondedTable.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,6CAA6C;;AAE/C;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;EACzB,kCAAkC;EAClC,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;AACtC;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".table [role='columnheader'] {\n  width: 38px !important;\n  min-width: 38px !important;\n  flex: 1 0 auto !important;\n  padding: 0 !important;\n  justify-content: center;\n  height: auto;\n  border-color: var(--color-base300) !important;\n\n}\n.table [role='columnheader']:first-child {\n  width: 100px !important;\n  max-width: 100px !important;\n  padding: 8px 10px 8px 10px !important;\n  justify-content: center;\n}\n\n.table [role='cell'] {\n  width: 38px !important;\n  min-width: 38px !important;\n  flex: 1 0 auto !important;\n  justify-content: center !important;\n  padding: 0 !important;\n  border-color: var(--color-base300) !important;\n}\n.table [role='cell']:first-child {\n  width: 100px !important;\n  max-width: 100px !important;\n  justify-content: center !important;\n  padding: 8px 10px 8px 10px !important;\n  min-height: 55px !important;\n}\n\n.table [role='cell']:last-child {\n  border-color: var(--color-base300) !important;\n}\n\n.table [role='row'] {\n  min-width: max-content !important;\n}\n\n.table > div:not([role='rowgroup']) > [role='row'] [role='columnheader']:first-child,\n.table > div:not([role='rowgroup']) > [role='row'] [role='columnheader']:nth-child(2) {\n  background-color: var(--color-base050) !important;\n}\n\n.table > div:not([role='rowgroup']) > [role='row'] [role='columnheader']:nth-child(3) {\n  background-color: #E2E6EA !important;\n}\n\n.table [role='cell']:first-child, .table [role='cell']:nth-child(2) {\n  background-color: var(--color-base050) !important;\n}\n\n.table [role='cell']:nth-child(3) {\n  background-color: #E2E6EA !important;\n}\n\n\n.table [role=\"row\"]:last-child [role='cell'] {\n  border-bottom: 0px;\n}\n\n.table > div:first-child > [role='row'] {\n  min-height: 55px !important;\n}\n\n.row {\n  width: 100%;\n  height: 100%;\n  font-size: 14px;\n  text-align: center;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `table_VyPWp`,
	"row": `row_APoki`
};
export default ___CSS_LOADER_EXPORT___;
